import { FranchiseShort } from "./franchise-short.model";

export class CourseConnected {
    id?: number;
    parent_id?: number;
    group_id?: number;
    franchise?: FranchiseShort;

    static fromJson(fields: any): CourseConnected {
        let item = Object.assign(new this(), fields);

        item.franchise = FranchiseShort.fromJson(fields?.franchise);

        return item;
    }
}
